// Production deploys the image staging built, so the bundle's build-time
// process.env.ENV is 'production' on both hosts. Resolve staging at runtime from
// the hostname so staging events don't land in production Sentry alerts.
const STAGING_HOSTNAME = 'staging.medsender.com';

export default function resolveSentryEnvironment(hostname = window.location.hostname) {
  if (hostname === STAGING_HOSTNAME) return 'staging';

  return process.env.ENV || process.env.NODE_ENV;
}
